pnk-radio-group {
    /* Component styles go here */
}
